/**
 * OCTOPUS Dashboard - FASE 3: Widget Library
 * TextDisplay - Display de texto para status e informações
 * 
 * Estilo: Marítimo/Industrial moderno, tema dark
 */

import React from 'react';

const TextDisplay = ({
  value = '',
  label = '',
  showLabel = true,
  size = 'medium', // 'small', 'medium', 'large'
  color = '#22c55e',
  align = 'center', // 'left', 'center', 'right'
}) => {
  // Tamanhos baseados no prop size
  const sizes = {
    small: {
      container: 'min-w-24 h-16',
      value: 'text-base',
      label: 'text-xs',
      padding: 'px-3 py-2',
    },
    medium: {
      container: 'min-w-32 h-20',
      value: 'text-lg',
      label: 'text-xs',
      padding: 'px-4 py-3',
    },
    large: {
      container: 'min-w-40 h-24',
      value: 'text-xl',
      label: 'text-sm',
      padding: 'px-5 py-4',
    },
  };

  const currentSize = sizes[size] || sizes.medium;
  
  const alignClass = {
    left: 'text-left items-start',
    center: 'text-center items-center',
    right: 'text-right items-end',
  }[align] || 'text-center items-center';

  const displayValue = value !== null && value !== undefined ? String(value) : '--';

  return (
    <div 
      className={`
        ${currentSize.container} ${currentSize.padding}
        flex flex-col justify-center ${alignClass}
        bg-gray-900 rounded-lg border border-gray-700
        relative overflow-hidden
      `}
    >
      {/* Efeito de glow no fundo */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{ 
          background: `radial-gradient(circle at center, ${color} 0%, transparent 70%)`,
        }}
      />

      {/* Label */}
      {showLabel && label && (
        <div className={`text-gray-400 ${currentSize.label} font-medium truncate w-full mb-1`}>
          {label}
        </div>
      )}

      {/* Valor (texto) */}
      <span 
        className={`font-semibold ${currentSize.value} truncate max-w-full`}
        style={{ 
          color: color,
          textShadow: `0 0 10px ${color}40`,
        }}
      >
        {displayValue}
      </span>
    </div>
  );
};

export default TextDisplay;
